/// <reference path="../../../Common/Helpers/GridEditorDialog.ts" />

namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class ClientFunctionTriggerParameterDialog extends Common.GridEditorDialog<ClientFunctionTriggerParameter> {
        protected getFormKey() { return "Workflow.ClientFunctionTriggerParameter"; }
        protected getNameProperty() { return "Name"; }
        protected getEntitySingular() { return "Parameter"; }

        protected form = new ClientFunctionTriggerParameterForm(this.idPrefix);

        private editorOptions: Serenity.PropertyGrid;

        constructor() {
            super();

            this.createOptionsGrid();

            this.form.Type.changeSelect2(() => {

                if (this.form.Type.value == Data.DataType.Guid.toString() ||
                    this.form.Type.value == Data.DataType.Date.toString() ||
                    this.form.Type.value == Data.DataType.DateTime.toString() ||
                    this.form.Type.value == Data.DataType.Time.toString() ||
                    this.form.Type.value == Data.DataType.Int16.toString() ||
                    this.form.Type.value == Data.DataType.Int32.toString() ||
                    this.form.Type.value == Data.DataType.Int64.toString() ||
                    this.form.Type.value == Data.DataType.Boolean.toString()) {
                    this.form.Size.value = null;
                }

                if (this.form.Type.value != Data.DataType.Decimal.toString() &&
                    this.form.Type.value != Data.DataType.Double.toString() &&
                    this.form.Type.value != Data.DataType.Single.toString()) {
                    this.form.Scale.value = null;
                }

                this.updateInterface();
            }); 


            this.form.EditorType.changeSelect2(e => this.createOptionsGrid());
        }

        protected updateInterface() {
            super.updateInterface();

            this.form.Size.getGridField().toggle(
                !!this.form.Type.value &&
                this.form.Type.value == Data.DataType.String.toString() ||
                this.form.Type.value == Data.DataType.Decimal.toString() ||
                this.form.Type.value == Data.DataType.Double.toString() ||
                this.form.Type.value == Data.DataType.Single.toString());

            this.form.Scale.getGridField().toggle(
                this.form.Type.value == Data.DataType.Decimal.toString() ||
                this.form.Type.value == Data.DataType.Double.toString() ||
                this.form.Type.value == Data.DataType.Single.toString());
        }

        public loadEntity(entity: ClientFunctionTriggerParameter) {
            super.loadEntity(entity);

            this.createOptionsGrid();
            this.editorOptions.load(entity.EditorParams || {});
        }

        protected getSaveEntity(): ClientFunctionTriggerParameter {
            var e = super.getSaveEntity();
            e.EditorParams = {};
            this.editorOptions.save(e.EditorParams);
            return e;
        }

        private createOptionsGrid() {
            var el: JQuery;
            if (this.editorOptions) {
                el = this.editorOptions.element;
                this.editorOptions.destroy();
                this.editorOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.propertyGrid.element);

            var items: Serenity.PropertyItem[];
            var editorType = this.form.EditorType.value;
            if (editorType) {
                var et = Q.getLookup<Data.DataReportEditorTypeItem>("Data.DataReportEditorType")
                    .itemById[editorType];
                if (et)
                    items = et.Options;
            }

            items = items || [];

            var index = Q.indexOf(items, x => x.name == "lookupKey");
            if (index > 0) {
                var item = items[index];
                items.splice(index, 1);
                items.splice(0, 0, item);
            }

            this.editorOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "Options_"
            });

            this.editorOptions.load({});
        }
    }
}